export enum EntityTypeLink {
    AREAS = 'areas',
    BACKLINKS = 'backlinks',
    BACKLINK_CATEGORIES = 'backlink-categories',
    CATEGORIES = 'categories',
    COLUMNS = 'columns',
    CSV_FILES = 'csv-files',
    CSV_RECORDS = 'csv-records',
    CUSTOMERS = 'customers',
    FILES = 'files',
    MENUS = 'menus',
    MENU_ITEMS = 'menu-items',
    PAGES = 'pages',
    PRODUCTS = 'products',
    TAGS = 'tags',
    USERS = 'users',
    WIDGETS = 'widgets',
    WIDGET_AREAS = 'widget-areas',
    DOMAINS = 'domains',
}